import {
  homePath,
  calendarIntegrationsPath,
  downloadsPath,
  pricingPath,
  featureListPath,
  newsListPath,
  bestPracticesListPath,
  aboutPath,
  careerListPath,
  engineeringListPath,
  resourceListPath,
  changelogListPath,
} from './path';

export interface CampaignCode {
  source?: string;
  medium?: string;
  campaign?: string;
  term?: string;
  content?: string;
}

export function toQueryString(obj?: any) {
  if (!obj) return '';
  const queryStrings: string[] = [];
  for (const [key, value] of Object.entries(obj)) {
    if (value === undefined || value === null) continue;
    if (typeof value === 'number' && isNaN(value)) continue;
    if (typeof value === 'string' && value === null) continue;
    queryStrings.push(`${key}=${value}`);
  }
  return queryStrings.join('&');
}

export function canonicalUrl(req: any, path: string) {
  return `https://${req.headers.host}${path}`;
}

export function authRedirectUrl(pathname: string) {
  const path = pathname || homePath();
  return `${process.env['JICOO_HOST']}${path}`;
}

export function inInternalUrl(asPath: string) {
  return asPath.startsWith('/_private');
}

export function inDashboardUrl(asPath: string) {
  return (
    asPath.startsWith('/dashboard') ||
    asPath.startsWith(calendarIntegrationsPath()) ||
    asPath.startsWith('/account') ||
    asPath.startsWith('/admin')
  );
}

export function isLandingUrl(pathname: string) {
  return (
    pathname === '/' ||
    pathname === downloadsPath() ||
    pathname === pricingPath() ||
    pathname.startsWith('/features') ||
    pathname.startsWith('/customers') ||
    pathname.startsWith(featureListPath()) ||
    pathname.startsWith(newsListPath()) ||
    pathname.startsWith(bestPracticesListPath()) ||
    pathname.startsWith(changelogListPath()) ||
    pathname.startsWith('/products')
  );
}

export function isMagazineUrl(pathname: string) {
  return pathname.startsWith(resourceListPath());
}

export function isAboutUrl(pathname: string) {
  return (
    pathname === '/' ||
    pathname.startsWith(aboutPath()) ||
    pathname.startsWith(careerListPath()) ||
    pathname.startsWith(engineeringListPath())
  );
}

export function isSkipAuthUrl(asPath: string) {
  return (
    asPath.startsWith('/apps') ||
    asPath.startsWith('/resources') ||
    asPath.startsWith('/login/teams')
  );
}

export function addCampaignCode(href: string, campaign: CampaignCode) {
  const url = new URL(
    href,
    process.env['JICOO_HOST'] || 'https://www.jicoo.com',
  );
  if (campaign.source) {
    url.searchParams.set('utm_source', String(campaign.source));
  }
  if (campaign.medium) {
    url.searchParams.set('utm_medium', String(campaign.medium));
  }
  if (campaign.campaign) {
    url.searchParams.set('utm_campaign', String(campaign.campaign));
  }
  if (campaign.content) {
    url.searchParams.set('utm_content', String(campaign.content));
  }
  if (campaign.term) {
    url.searchParams.set('utm_term', String(campaign.term));
  }
  return url.toString();
}
